import { useState } from "react";

const useStepper = (totalSteps) => {
  const [currentStep, setCurrentStep] = useState(1);

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  return {
    currentStep,
    totalSteps,
    nextStep,
    prevStep,
  };
};

export default useStepper;